import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edf28b9a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=edf28b9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf28b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edf28b9a')) {
      api.createRecord('edf28b9a', component.options)
    } else {
      api.reload('edf28b9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=edf28b9a&scoped=true", function () {
      api.rerender('edf28b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/settings/index.vue"
export default component.exports